import apm from "tools/config/apm"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export const useApmRouteTracking = () => {
  const location = useLocation()

  useEffect(() => {
    const name = location.pathname
    const transaction = apm.startTransaction(name, 'route-change')

    return () => {
      transaction?.end()
    }
  }, [location.pathname])
}